"use client";

//import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import CAgGrid from "./CAgGrid";
import CDropdown from "./CDropdown";

import { GetInquiryDataByStatus } from "../services/inquiryService";
import { GetUserDetailsByRoleId } from "../services/userService";

const CInquiryData = forwardRef(({
  userId = null,
  done = null,
  salesDone = null,
  orderPunchDone = null,
  statusId = null,
  columnDefs = [],
  h4 = "",
  IsAdmin = false,
  IsSales = false,
  IsPunch = false,
}, ref) => {
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [users, setUsers] = useState([]);
  const [errors, setErrors] = useState({});
  const [userPermissionRoleId, setUserPermissionRoleId] = useState(null);

  // const [formData, setFormData] = useState({
  //   teleCallName: "",
  // });

  const [search, setSearch] = useState({
    userId,
    done: null,
    salesDone: null,
    orderPunchDone,
    followUpStatusId: IsPunch ? 3 : statusId,
});

  const abortRef = useRef(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setUserPermissionRoleId(
        Number(localStorage.getItem("userPermissionRoleId"))
      );
    }
  }, []);

  useEffect(() => {
    setSearch({
        userId,
        done: null,
        salesDone: null,
        orderPunchDone,
        followUpStatusId: IsPunch ? 3 : statusId,
    });
}, [userId, orderPunchDone, statusId, IsPunch]);

  useEffect(() => {
    if (!userPermissionRoleId) return;

    const fetchUsers = async () => {
      try {
        const response = await GetUserDetailsByRoleId(userPermissionRoleId);

        if (response?.success && response?.statusCode === 200) {
          setUsers(response.data || []);
        } else {
          setUsers([]);
          setErrors((prev) => ({
            ...prev,
            form: response?.message || "Failed to fetch users.",
          }));
        }
      } catch (err) {
        console.error(err);

        setUsers([]);

        setErrors((prev) => ({
          ...prev,
          form: err.message || "Something went wrong.",
        }));
      }
    };

    fetchUsers();
  }, [userPermissionRoleId]);

  const defaultColDef = useMemo(
    () => ({
      flex: 1,
      sortable: true,
      filter: true,
      floatingFilter: true,
      resizable: true,
    }),
    []
  );
const maskMobile = (mobile) => {
  if (!mobile) return "";

  mobile = mobile.toString();

  // // 9876543210 => 987****210
  // return `${mobile.substring(0, 3)}****${mobile.substring(7)}`;
  // 9876543210 => 98765432**
  return `${mobile.slice(0, -2)}**`;
};

const mapOrders = useCallback((data = []) => {
  const hideMobile = data.length > 1;

  return data.map((item, index) => ({
    id: item.id,
    name: item.name,
    consultation: item.consultation,

    // Show only first mobile, hide remaining
    mobile: hideMobile
      ? index === 0
        ? item.mobile
        : maskMobile(item.mobile)
      : item.mobile,

    address: item.address,
    city: item.city,
    state: item.state,
    pinCode: item.pinCode,
    followUpSts: item.followUpSts,
    followUpDate: item.followUpDate,
    assignName:item.assignName,
    assignDate:item.assignDate,
    remarks: item.remarks,
    isdone: item.isdone,
    issales: item.issales,
    ispunch: item.ispunch,
  }));
}, []);

  const fetchOrders = useCallback(async () => {
    try {
      abortRef.current?.abort();

      const controller = new AbortController();
      abortRef.current = controller;

      setLoading(true);
     const salesDone =
    IsAdmin
        ? search.salesDone
        : IsSales
        ? search.salesDone
        : null;

const orderPunchDone =
    IsAdmin
        ? search.orderPunchDone
        : IsPunch
        ? true
        : null;

const followUpStatusId = IsPunch ? 3 : search.followUpStatusId;

        const response = await GetInquiryDataByStatus(
    search.userId,
    search.done,
    salesDone,
    orderPunchDone,
    followUpStatusId,
    {
        signal: controller.signal,
    }
);

      if (response?.success) {
        setRowData(mapOrders(response.data || []));
      } else {
        setRowData([]);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error(error);
        setRowData([]);
      }
    } finally {
      setLoading(false);
    }
  }, [search, mapOrders, IsAdmin, IsSales, IsPunch]);

  useEffect(() => {
    fetchOrders();

    return () => abortRef.current?.abort();
  }, [fetchOrders]);
  useImperativeHandle(ref, () => ({
    refresh: fetchOrders
  }));

  const handleInputChange = (field, value) => {
    setSearch((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleTeleCallerChange = (e) => {
    const value = e.target.value ? Number(e.target.value) : null;

    // setFormData((prev) => ({
    //   ...prev,
    //   teleCallName: value,
    // }));

    handleInputChange("userId", value);
  };

  return (
    <>
      <h4 className="mb-3">{h4}</h4>

      <div className="row g-3 mb-3">
        {IsAdmin && (
          <div className="col-md-3">
            <CDropdown
              label="Tele Caller Name"
              name="teleCallName"
              value={search.userId ?? ""}
              options={users}
              optionLabel="userName"
              optionValue="id"
              firstOption="Select Name"
              required
              error={errors.teleCallName}
              onChange={handleTeleCallerChange}
            />
          </div>
        )}
        {(IsAdmin || IsSales) && (
          <>
            <div className="col-md-3">
              <label className="form-label">User Id</label>

              <input
                type="number"
                className="form-control"
                value={search.userId ?? ""}
                onChange={(e) =>
                  handleInputChange(
                    "userId",
                    e.target.value ? Number(e.target.value) : null
                  )
                }
                readOnly
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">Follow Up Status</label>

              <select
                className="form-select"
                value={search.followUpStatusId ?? ""}
                onChange={(e) =>
                  handleInputChange(
                    "followUpStatusId",
                    e.target.value ? Number(e.target.value) : null
                  )
                }
              >
                <option value="">All</option>
                <option value="1">Interested</option>
                <option value="2">Not Interested</option>
                <option value="4">Ringing</option>
                <option value="3">Closed</option>
              </select>
            </div>

            {/* <div className="col-md-2">
              <label className="form-label">Ringing</label>

              <select
                className="form-select"
                value={search.done === null ? "" : String(search.done)}
                onChange={(e) =>
                  handleInputChange(
                    "done",
                    e.target.value === ""
                      ? null
                      : e.target.value === "true"
                  )
                }
              >
                <option value="">All</option>
                <option value="true">Done</option>
                <option value="false">Pending</option>
              </select>
            </div>

            <div className="col-md-2">
              <label className="form-label">Deny</label>

              <select
                className="form-select"
                value={search.salesDone === null ? "" : String(search.salesDone)}
                onChange={(e) =>
                  handleInputChange(
                    "salesDone",
                    e.target.value === ""
                      ? null
                      : e.target.value === "true"
                  )
                }
              >
                <option value="">All</option>
                <option value="true">Done</option>
                <option value="false">Pending</option>
              </select>
            </div> */}
          </>
        )}
       {/* {(IsAdmin || IsPunch) && (
          <>
            <div className="col-md-2">
              <label className="form-label">Order Punch Done</label>

              <select
                className="form-select"
                value={
                  search.orderPunchDone === null
                    ? ""
                    : String(search.orderPunchDone)
                }
                onChange={(e) =>
                  handleInputChange(
                    "orderPunchDone",
                    e.target.value === ""
                      ? null
                      : e.target.value === "true"
                  )
                }
              >
                <option value="">All</option>
                <option value="true">Done</option>
                <option value="false">Pending</option>
              </select>
            </div>
          </>
        )}
        <div className="col-md-2 d-flex align-items-end">
          <button
            className="btn btn-primary w-100"
            onClick={fetchOrders}
            disabled={loading}
          >
            {loading ? "Loading..." : "Search"}
          </button>
        </div> */}
      </div> 

      {errors.form && (
        <div className="alert alert-danger">
          {errors.form}
        </div>
      )}

      <div className="mb-3">
        <strong>Total Records:</strong> {rowData.length}
      </div>

      <CAgGrid
    rowData={rowData}
    columnDefs={columnDefs}
    loading={loading}
    defaultColDef={defaultColDef}
    pagination
    paginationPageSize={10}
    rowSelection="multiple"
    height="450px"
/>
    </>
  );
});

export default CInquiryData;